import { ref, readonly } from 'vue'

const visible = ref(false)
const transitionState = ref('closed')

const open = () => {
  visible.value = true
}

const close = () => {
  visible.value = false
}

const toggle = () => {
  visible.value = !visible.value
}

export const useAmbiCard = () => {
  return {
    visible: readonly(visible),
    open,
    close,
    toggle,
    transitionState
  }
}
